import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserX, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

// Feb 2026 — Impersonate feature. Banner merah tampil di atas semua halaman
// selama sesi impersonate aktif. Tombol "Kembali ke Akun Saya" panggil
// stopImpersonate() dan restore token asli.
export default function ImpersonationBanner() {
  const { isImpersonating, originalUser, user, stopImpersonate } = useAuth();
  const navigate = useNavigate();
  const [stopping, setStopping] = useState(false);

  if (!isImpersonating) return null;

  const targetName = user?.name || user?.user_id || "-";
  const targetRole = user?.role || "-";
  const impersonatorName = originalUser?.name || originalUser?.user_id || "Anda";

  const handleStop = async () => {
    setStopping(true);
    try {
      const restored = await stopImpersonate();
      // Redirect ke landing role asli agar tidak stuck di route yang tidak
      // diizinkan untuk role restored (mis. marketing di /admin/nurses).
      const role = restored?.role || originalUser?.role;
      if (["admin", "super_admin", "master_admin", "supervisor", "hrd"].includes(role)) {
        navigate("/admin/dashboard", { replace: true });
      } else if (role === "marketing") {
        navigate("/marketing/orders", { replace: true });
      } else if (role === "finance") {
        navigate("/finance/dashboard", { replace: true });
      } else if (role === "nakes") {
        navigate("/nakes/jobs", { replace: true });
      } else if (role === "gudang") {
        navigate("/gudang/dashboard", { replace: true });
      }
    } catch (e) {
      toast.error("Gagal kembali ke akun: " + (e?.message || "unknown"));
    } finally {
      setStopping(false);
    }
  };

  return (
    <div
      data-testid="impersonation-banner"
      className="sticky top-0 z-[9999] w-full bg-red-600 text-white shadow-lg"
      role="alert"
    >
      <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 py-2 text-sm">
        <UserX className="h-5 w-5 shrink-0" />
        <div className="flex-1 leading-tight">
          <span className="font-semibold">Mode Impersonate Aktif</span>
          <span className="mx-2 opacity-80">·</span>
          <span>
            Anda ({impersonatorName}) sedang login sebagai{" "}
            <b data-testid="impersonation-target-name">{targetName}</b>{" "}
            (<span data-testid="impersonation-target-role">{targetRole}</span>)
          </span>
        </div>
        <button
          type="button"
          onClick={handleStop}
          disabled={stopping}
          data-testid="impersonation-stop-btn"
          className="inline-flex items-center gap-1.5 rounded-md bg-white/15 px-3 py-1.5 text-xs font-semibold hover:bg-white/25 disabled:opacity-60"
        >
          {stopping ? (
            <>
              <Loader2 className="h-3.5 w-3.5 animate-spin" />
              Kembali...
            </>
          ) : (
            "Kembali ke Akun Saya"
          )}
        </button>
      </div>
    </div>
  );
}
